<template>
  <component :is="icon" :fill="colorHex" :secondaryfill="secondaryColorHex" />
</template>

<script setup>
import tailwindConfig from 'tailwind-config'
import { computed, onBeforeMount, ref, watch } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: 'currentColor',
  },
  secondaryColor: {
    type: String,
    default: null,
  },
})

const icon = ref(null)

const colorHex = computed(() => {
  return props.color === 'currentColor'
    ? 'currentColor'
    : getHexColor(props.color)
})
const secondaryColorHex = computed(() => {
  return props.secondaryColor
    ? getHexColor(props.secondaryColor)
    : colorHex.value
})

watch(
  () => props.name,
  async () => {
    await dynamicLoadIcon()
  },
)

const getHexColor = (color) => {
  const inputArray = color.split('-')
  const colorKey = inputArray[0]

  if (typeof tailwindConfig.theme.colors[colorKey] === 'string') {
    return tailwindConfig.theme.colors[colorKey]
  } else {
    const colorNumber = inputArray[1]
    return tailwindConfig.theme.colors[colorKey][colorNumber]
  }
}

const dynamicLoadIcon = async () => {
  const module = await import(`../../assets/icons/${props.name}.vue`)
  icon.value = module.default
}

onBeforeMount(() => {
  dynamicLoadIcon()
})
</script>
